import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {Subscription} from 'rxjs/Subscription';
import {Observable, Subject} from 'rxjs';

import {SolarEmailService} from '../../service/emails.service';
import {NotificationService} from 'app/core/services/notification.service';
import {ConfigService} from 'app/core/services/config.service';

import {SmartModalService} from 'app/core/services/smart-modal.service';
import {RxComponent} from 'app/core/components/common/rx.component';
import {BuyerEmailDetails} from './buyer-email-details.model';

@Component({
    selector: 'itpx-email-details',
    templateUrl: './email-details.component.html',
    styleUrls: ['./email-details.component.css']
})

export class SolarEmailDetailsComponent extends RxComponent implements OnInit, OnDestroy {

    private sub: Subscription;
    private details: any;
    private id: string;
    private url: string;
    private isInProgress: boolean = false;
    private refresh = new Subject();

    private buttons: Array<any> = [
        {
            title: 'Resend email',
            action: 'resend',
            icon: 'fa-repeat',
            class: 'btn-primary',
            disabled: false
        }
    ];

    constructor(private emailService: SolarEmailService,
                private notificationService: NotificationService,
                private configService: ConfigService,
                private route: ActivatedRoute,
                private router: Router,
                private modalService: SmartModalService) {
        super();
    }

    ngOnInit() {
        this.isInProgress = true;
        this.sub = this.route.params
            .subscribe(params => {
            this.id = params['id'];
            this.url = this.configService.get('server').url + this.configService.get('endpoints').tm.email.details.api + '/' + this.id;
            this.loadData();
        });
        this.refresh.subscribe(_ => {
            this.isInProgress = true;
            this.loadData();
        })
    }

    private loadData(): void {
        this.emailService.getEmailDetails(this.id)
            .bindToLifecycle(this)
            .subscribe(
                data => {
                    this.extractData(data);
                    setTimeout(()=>this.loadIframe(), 100)
                }, error => this.isInProgress = false
            );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private extractData(body: any) {
        this.details = <BuyerEmailDetails>body.data;
    }

    private loadIframe(){
        let iframeDocument = document.querySelector('#email-holder')['contentWindow'].document;
        iframeDocument.open('text/html', 'replace');
        iframeDocument.write(this.details.html);
        iframeDocument.close();
    }

    public resend() {
        this.isInProgress = true;
        this.emailService.resend(this.details.id)
            .subscribe(
                data => {
                    this.isInProgress = false;
                    this.notificationService.success(
                        'Successfully resend email ',
                        'Success'
                    );
                    this.refresh.next(true);
                },
                error => this.isInProgress = false
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/emails/components/details/email-details.component.ts